module.exports = __webpack_public_path__ + "img/Asiatic Finance.238af415.png";